/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Create payload; the class always belongs to the organization of the request header.
 * @export
 * @interface UserClassGroupCreate
 */
export interface UserClassGroupCreate {
    /**
     * 
     * @type {string}
     * @memberof UserClassGroupCreate
     */
    name: string;
}

/**
 * Check if a given object implements the UserClassGroupCreate interface.
 */
export function instanceOfUserClassGroupCreate(value: object): value is UserClassGroupCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserClassGroupCreateFromJSON(json: any): UserClassGroupCreate {
    return UserClassGroupCreateFromJSONTyped(json, false);
}

export function UserClassGroupCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserClassGroupCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UserClassGroupCreateToJSON(json: any): UserClassGroupCreate {
    return UserClassGroupCreateToJSONTyped(json, false);
}

export function UserClassGroupCreateToJSONTyped(value?: UserClassGroupCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

